import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import { ReportSummary } from '../../services/webFilter.service';
import { Approval } from '../../services/reportReview.service';
import ApprovalBox from '../report/ApprovalBox';

interface Props {
  data: ReportSummary | null;
  isPdfMode?: boolean;
  approval?: Approval | null;
}

const WfReportSummary: React.FC<Props> = ({ data, isPdfMode, approval = null }) => {
  return (
    // DLP·EDR 요약과 같은 구조 — 공용 .tab-panel / .summary-content / .markdown-content 규칙(DlpReportPage.css)을 쓴다
    <div className={`tab-panel ${isPdfMode ? 'pdf-page-break' : ''}`}>
      <div className="report-approval-header">
        <h2 className={isPdfMode ? 'wf-pdf-section-title' : undefined}>📄 요약</h2>
        <ApprovalBox approval={approval} />
      </div>
      {data?.summaryContent ? (
        <div className="summary-content">
          <div className="markdown-content">
            <ReactMarkdown remarkPlugins={[remarkBreaks]}>{data.summaryContent}</ReactMarkdown>
          </div>
        </div>
      ) : (
        <p className="no-content">요약 내용이 없습니다.</p>
      )}
    </div>
  );
};

export default WfReportSummary;
